/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約者情報
 */
export interface Sgkb986aResCtrperInfoDto {
    /**
     * 内部お客さま番号
     */
    visitNo?: string;
    /**
     * お客さま漢字氏名
     */
    visitName?: string;
    /**
     * お客さまカナ氏名
     */
    visitKanaName?: string;
    /**
     * お客さま電話番号１コード
     */
    telNoDiv1?: string;
    /**
     * お客さま電話番号１コード名称
     */
    telNoDiv1Aname?: string;
    /**
     * お客さま電話１番号
     */
    telNo1?: string;
    /**
     * お客さま電話番号２コード
     */
    telNoDiv2?: string;
    /**
     * お客さま電話番号２コード名称
     */
    telNoDiv2Aname?: string;
    /**
     * お客さま電話２番号
     */
    telNo2?: string;
    /**
     * お客さま電話番号３コード
     */
    telNoDiv3?: string;
    /**
     * お客さま電話番号３コード名称
     */
    telNoDiv3Aname?: string;
    /**
     * お客さま電話３番号
     */
    telNo3?: string;
    /**
     * 外部連携ID
     */
    extLinkId?: string;
}

